import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { WsUserProfileService } from 'src/app/ws/wsUserProfile/ws-user-profile.service';
import { debounceTime, lastValueFrom } from 'rxjs';
import { MAddressListRequest, MAddressRequest, MAddressResponseData } from 'src/app/pages/user/user.module';
import { SharedPrefrences } from 'src/app/utils/utils.service';
import { ToastrService } from 'ngx-toastr';
import { CommonBehaviorChangeService } from 'src/app/utils/common-behaviour-service';
@Component({
  selector: 'app-add-address',
  templateUrl: './add-address.component.html',
  styleUrls: ['./add-address.component.scss']
})
export class AddAddressComponent {
  @Input() addressData?: any;
  @Input() viewForm: any;
  @Input() from: any;
  @Output() saveClickAddress = new EventEmitter();
  @Output() saveClickProfile = new EventEmitter();
  @Output() saveClickCheckout = new EventEmitter();
  mAddressReq: MAddressRequest = new MAddressRequest();
  mAddressResponseData?: MAddressResponseData;
  addressFormgroup!: FormGroup;
  emailFormgroup!: FormGroup;
  mAddressListReq: MAddressListRequest = new MAddressListRequest();
  id: any;
  addressList: any = [];
  userData: any;
  profileData: any;
  isLoading: boolean = false;


  constructor(private formBuilder: FormBuilder, private toast: ToastrService,private _commonBehaviorChangeService: CommonBehaviorChangeService,
    private wsUserProfileService: WsUserProfileService) {
   
  }
  get getAddressForm() {
    return this.addressFormgroup.controls;
  }

  ngOnChanges() {
    this.addressFormgroup = this.formBuilder.group({
      contact_number1: new FormControl('', [Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]),
      address_line1: new FormControl('', [Validators.required]),
      first_name: new FormControl('', [Validators.required]),
      last_name: new FormControl('', [Validators.required]),
      postal_code: new FormControl('',[Validators.required]),
      state_name: new FormControl('',[Validators.required]),
      city: new FormControl('',[Validators.required]),
      is_default: new FormControl(false)
    });
    if (this.viewForm == 'edit') {
      this.addUpdateAddress();
      this.addressFormgroup.get('postal_code')?.valueChanges.pipe(
        debounceTime(300) 
      ).subscribe((data:any) => {
        if(this.addressFormgroup.controls['postal_code'].value && this.addressFormgroup.controls['postal_code'].value.length>4){
            this.checkPinCode(this.addressFormgroup.controls['postal_code'].value);
        }
      });
    }
    else if (this.viewForm == 'add'){
      this.addNewAddress();
      this.id = SharedPrefrences.getUserId();
     
      this.mAddressListReq.userId = this.id
      this.getAddressList(this.mAddressListReq)
      this.addressFormgroup.controls['postal_code']?.valueChanges.pipe(
        debounceTime(300) 
        ).subscribe((data:any) => {
        if(this.addressFormgroup.controls['postal_code'].value && this.addressFormgroup.controls['postal_code'].value.length>4)
        this.checkPinCode(this.addressFormgroup.controls['postal_code'].value);
      });
    }
  }

  async getAddressList(userId: any) {
    this.addressList = []
    const addressList = this.wsUserProfileService.getAddressList(userId)
    await lastValueFrom(addressList).then(async response => {
      if (response && response.statusCode == 200) {
        this.addressList = response.data
      }
    })
  }

  /**
  * On Click Button
  */
  async onSubmit() {
    this.isLoading = true;
    if (this.viewForm == 'add') {
      this.addAddress();
    } else {
      this.updateAddress();
    }
  }


  addNewAddress(){
    this.addressFormgroup.controls['address_line1'].setValue('')
    this.addressFormgroup.controls['contact_number1'].setValue('')
    this.addressFormgroup.controls['state_name'].setValue('')
    this.addressFormgroup.controls['city'].setValue('')
    this.addressFormgroup.controls['postal_code'].setValue('')
    this.addressFormgroup.controls['is_default'].setValue(false)
    this.addressFormgroup.controls['first_name'].setValue('')
    this.addressFormgroup.controls['last_name'].setValue('')
  }

  /**
  * Date:- 13-06-2023
  * Method :- This method is used to Set Address Details In Edit Form
  */

  addUpdateAddress() {
    this.mAddressReq.id = this.addressData?.id
    this.mAddressResponseData = this.addressData
    this.addressFormgroup.controls['address_line1'].setValue(this.addressData?.address_line1)
   this.addressFormgroup.controls['first_name'].setValue(""+this.addressData?.name.split(' ')[0])
   this.addressFormgroup.controls['last_name'].setValue(""+this.addressData?.name.split(' ')[1])
    this.addressFormgroup.controls['contact_number1'].setValue(this.addressData?.contact_number1)
    this.addressFormgroup.controls['state_name'].setValue(this.addressData?.state_name)
    this.addressFormgroup.controls['city'].setValue(this.addressData?.city)
    this.addressFormgroup.controls['postal_code'].setValue(this.addressData?.postal_code)
    this.addressFormgroup.controls['is_default'].setValue(this.addressData?.is_default as boolean)
  }

  /**
  * Date:- 13-06-2023
  * Method :- This method is used to Add Address
  * @param mAddressReq :-  This param is used for request to Add Address Details
  */
  async addAddress() {
    this.isLoading = true;
    if (this.addressFormgroup.invalid){
      this.addressFormgroup.markAllAsTouched()
      this.isLoading = false;
      return ;
    }

    const checkAddress = this.wsUserProfileService.checkPinCode(this.addressFormgroup.controls['postal_code'].value)
    await lastValueFrom(checkAddress).then(async response => {
      if(response[0] && response[0].Status == 'Success'){
        this.mAddressReq.use_id = SharedPrefrences.getUserId()!;
        this.mAddressReq.name = this.addressFormgroup.controls['first_name'].value + ' ' +  this.addressFormgroup.controls['last_name'].value
        this.mAddressReq.address_line1 = this.addressFormgroup.controls['address_line1'].value
        this.mAddressReq.country_id = 2
        this.mAddressReq.state_name = this.addressFormgroup.controls['state_name'].value
        this.mAddressReq.city = this.addressFormgroup.controls['city'].value
        this.mAddressReq.postal_code = this.addressFormgroup.controls['postal_code'].value
        this.mAddressReq.is_default = this.addressFormgroup.controls['is_default'].value as boolean
        this.mAddressReq.contact_number1 = this.addressFormgroup.controls['contact_number1'].value
        const addAddress = this.wsUserProfileService.addAddress(this.mAddressReq)
        await lastValueFrom(addAddress).then(async response => {
          if (response && response.statusCode == 200) {
            this.isLoading = false;
            if(this.addressList.length == 0){
              this.userData = JSON.parse(""+SharedPrefrences.getUserData());
              if(this.userData.email && this.userData.email != ''){
                this.profileData = {
                  'first_name':this.addressFormgroup.controls['first_name'].value,
                  'last_name':this.addressFormgroup.controls['last_name'].value,
                  'id':this.id,
                  'email':this.userData.email
                }
                this.updateProfile(this.profileData)
                this.resetForm();
                this.closeModal(response);
              }else{
               
                this.profileData = {
                  'first_name':this.addressFormgroup.controls['first_name'].value,
                  'last_name':this.addressFormgroup.controls['last_name'].value,
                  'id':this.id,
                  'email':this.userData.email,
                  'emailShow':true
                }
                this.closeModal(this.profileData);
              }
            }else{
              this.resetForm();
              this.closeModal(response);
            }
          } else {
            this.isLoading = false;
             }
            })
          }else{
            this.isLoading = false;
            this.toast.error("Please enter valid Pincode")
          }
        });
      }

      async updateProfile(profileData:any){
        const updateProfile = this.wsUserProfileService.updateProfile(profileData)
        await lastValueFrom(updateProfile).then(async response => {
          if (response && response.statusCode == 200) {
            SharedPrefrences.setUserData(response.data)
            this._commonBehaviorChangeService.updateProfileData(true)
            this.isLoading = false;
            window.location.reload();
          } else {
            this.isLoading = false;
          }
        })
    
      }

  
    async checkPinCode(pincode: any){
      const checkAddress = this.wsUserProfileService.checkPinCode(pincode)
      await lastValueFrom(checkAddress).then(response=>{
        if(response[0] && response[0].Status == 'Success'){
          this.addressFormgroup.controls['city'].setValue(response[0].PostOffice[0].Block);
          this.addressFormgroup.controls['state_name'].setValue(response[0].PostOffice[0].State);      
        }
        else{
          this.toast.error('Please enter a valid Pincode')
        }
      })
    }

  closeModal(response:any){
    if(this.from == 'address'){
      this.saveClickAddress.emit(response);
    }else if (this.from == 'profile'){
      this.saveClickProfile.emit(response);
    }else{
      this.saveClickCheckout.emit(response);
    }
    }
  

  /**
  * Date:- 13-06-2023
  * Method :- This method is used to Update Address
  * @param mAddressReq :-  This param is used for request to Update Address Details
  */
  async updateAddress() {
    this.isLoading = true;
    if (this.addressFormgroup.invalid){
      this.isLoading = false;
      this.addressFormgroup.markAllAsTouched()
      return;
    }

    this.mAddressReq.id = this.mAddressResponseData?.id
    this.mAddressReq.use_id = SharedPrefrences.getUserId()!;
    this.mAddressReq.name = this.addressFormgroup.controls['first_name'].value + ' ' +  this.addressFormgroup.controls['last_name'].value
    this.mAddressReq.address_line1 = this.addressFormgroup.controls['address_line1'].value
    this.mAddressReq.country_id = 2
    this.mAddressReq.state_name = this.addressFormgroup.controls['state_name'].value
    this.mAddressReq.city = this.addressFormgroup.controls['city'].value
    this.mAddressReq.postal_code = this.addressFormgroup.controls['postal_code'].value
    this.mAddressReq.is_default = this.addressFormgroup.controls['is_default'].value as boolean
    this.mAddressReq.contact_number1 = this.addressFormgroup.controls['contact_number1'].value
    const updateAddress = this.wsUserProfileService.updateAddress(this.mAddressReq)
    await lastValueFrom(updateAddress).then(async response => {
      if (response && response.statusCode == 200) {
        this.isLoading = false;
        this.resetForm();
        if(this.from == 'address'){
          this.saveClickAddress.emit(response);
        }else if (this.from == 'profile'){
          this.saveClickProfile.emit(response);
        }else{
          this.saveClickCheckout.emit(response);
        }
      } else {
        this.isLoading = false;
      }
    })
  }

  /**
  * Date:- 14-06-2023
  * Method :- This method is used to reset form
  */
  resetForm() {
    this.addressFormgroup.reset();
  }



}
